import { baseUrl } from "../constants";
import apiFunctions from "./axiosConfig/apiFunctions";
import CustomToast from "../components/Toast";

 export const fetchTemplateData = async (searchtext) => {
    try {
      searchtext=searchtext?.length>1?searchtext:'';
      const responseGet = await apiFunctions.fetchData(`${baseUrl}getTemplateList?pageNumber=1&limit=100&search=${searchtext}`);
      return responseGet;
    } catch (error) {
      CustomToast.error('Error while fetcing course data')
        return error;
    } 
  };

export const createTemplate = async (postData) => {
  try {
    // POST request
    const response = await apiFunctions.postData(`${baseUrl}createTemplate`, postData);
    return {
      success: true,
      data: response.data,
      
    };
  } catch (error) {
    const message = error?.response?.data?.message || 'Unexpected error occurred.';
    return {
      success: false,
      message,
    };
  }
};

 export const deleteTemplate = async (id) => {
  try {
    // DELETE request
    const responseGet = await apiFunctions.deleteData(`${baseUrl}deleteTemplate/${id}`);
    CustomToast.success('Template deleted successfully');
    return responseGet;
  } catch (error) {
    CustomToast.error('Error while deleting template');
    return error;
  }
};

export const updateTemplate = async (id, updateData) => {
  try {
    const response = await apiFunctions.putData(`${baseUrl}updateTemplate/${id}`, updateData);
    CustomToast.success('Template updated successfully');
     return {
      success: true,
      data: response?.data,
    };
  } catch (error) {
    const message = error?.response?.data?.message || 'Unexpected error occurred.';

    return {
      success: false,
      message,
    };
  }
};

export const getTemplateDetails = async (id) => {
  try {
    const response = await apiFunctions.fetchData(`${baseUrl}templateDetails/${id}`);
    return response;
  } catch (error) {
    CustomToast.error('Error while fetching template details');
    return error;
  }
};

export const publishTemplate = async (id, data) => {
  try {
    const response = await apiFunctions.putData(`${baseUrl}publishTemplate/${id}`, data);
    // CustomToast.success('Case Study published successfully');
    return response;
  } catch (error) {
    // CustomToast.error('Error while publishing Template');
    return error;
  }
};

export const handleUploadFiles = async (files) => {
  const formData = new FormData();
  
  files.forEach(file => {
    formData.append('files', file); // Append each file under the same field name
  });

  try {
    const response = await apiFunctions.uploadDocFiles(`${baseUrl}uploadFiles`, formData);
    CustomToast.success('Files uploaded successfully');
    return response;
  } catch (error) {
    CustomToast.error('Error while uploading files');
    return error;
  }
};

export const deleteUploadedTemplateFile = async (templateId, fileId) => {
  try {
    const response = await apiFunctions.deleteData(
      `${baseUrl}deleteTemplateUploadFile/${templateId}/${fileId}`
    );
    return response;
  } catch (error) {
    console.error("Failed to delete file:", error);
    throw error;
  }
};




